//
//
//
//
//
//

import icon from "../icon";
import X32icfullscreenoffSvg from "./x32icfullscreenoff.svg?inline";
export default {
  name: "x32icfullscreenoffIcon",
  components: {
    X32icfullscreenoffSvg,
    icon,
  },
};
